import type { FC } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { IconButton } from "@similarweb/ui-components";

import GrandAccessBanner from "app/pages/sales-intelligence/common-components/GrandAccessBanner/GrandAccessBanner";
import { openHooksModalV5 } from "app/services/ModalService";

import { StyledHookOptionContainer } from "./styles";

type Props = {
    title?: string;
    description?: string;
    buttonText?: string;
};

export const ListHookOption: FC<Props> = ({
    title = "si.lists.actions.hook.title",
    description = "si.lists.actions.hook.subtitle",
    buttonText = "si.common.contact_us",
}) => {
    const { translate } = useTranslate();

    return (
        <StyledHookOptionContainer>
            <GrandAccessBanner
                title={translate(title)}
                description={translate(description)}
                button={
                    <IconButton
                        type="trial"
                        onClick={() => {
                            openHooksModalV5("SalesSolutionLists");
                        }}
                        iconName="sparkles"
                    >
                        {translate(buttonText)}
                    </IconButton>
                }
            />
        </StyledHookOptionContainer>
    );
};
